import { Container } from '@/components/Layout/Container';
import { AccountSettings } from '@/components/Settings/AccountSettings';
import { PreferenceSettings } from '@/components/Settings/PreferenceSettings';
import { useAuth } from '@/context/AuthContext';
import { Navigate } from 'react-router-dom';

export function SettingsPage() {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <Container>
      <div className="py-8 space-y-8">
        <div>
          <h1 className="text-3xl font-bold">Settings</h1>
          <p className="text-muted-foreground mt-2">
            Manage your account settings and preferences
          </p>
        </div>

        <div className="space-y-6">
          <AccountSettings />
          <PreferenceSettings />
        </div>
      </div>
    </Container>
  );
}